import { api } from '@/api';

/**
 * Response from `admin-utils/list-org-expired-cases`. Returns the ids of every
 * case that is already past its retention period for the organisation the
 * global admin has currently switched into — i.e. the cases that
 * `admin-utils/purge-org-expired-cases` would delete.
 */
export interface ListOrgExpiredCasesResponse {
  expiredCaseIds: string[];
}

const listOrgExpiredCasesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getListOrgExpiredCases: builder.query<ListOrgExpiredCasesResponse, void>({
      query: () => ({
        url: `admin-utils/list-org-expired-cases`,
        method: 'GET',
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetListOrgExpiredCasesQuery } = listOrgExpiredCasesApi;
